import { Check, Pencil, Tag, Trash2, X } from "lucide-react";
import { useContext, useState } from "react";
import { useApi } from "../../../hooks/api.hook";
import { ToasterContext } from "../../../contexts/toaster.context";
import { AuthContext } from "../../../contexts/auth.context";
import useForm from "../../../hooks/form.hook";
import { ILabel } from "../../../shared/type/list.type";
import { IUser } from "../../../shared/type/user.type";

export default function EditLabel({label}: {
    label: ILabel;
}) {
    const service = useApi(`label/${label.id}`);
    const toaster = useContext(ToasterContext);
    const auth = useContext(AuthContext);

    const form = useForm({
        label: label.value
    });

    // const [input, setInput] = useState(label.value);
    const [edit, setEdit] = useState(false);

    async function Update() {
        const res = await form.submit(`label/${label.id}`, {
            method: "PUT",
            onSuccess: (data: IUser) => {
                auth.setUser(data);
            }
        });

        setEdit(false);
    }

    const Delete = async () => {
        form.setIsLoading(true);
        const res = await service.delete();
        form.setIsLoading(false);
        if (!res.ok && res.data?.message) {
            toaster.makeToast(res.data.message);
            return;
        }
        
        auth.setUser(res.data);
        setEdit(false);
    }

    return (
        <div className="flex items-center gap-4 py-2">
            <div className="px-4">
                <p><Tag /></p>
            </div>
            <div className="flex-1">
                {edit ? (
                    <input disabled={form.isLoading} type="text" value={form.state.label} onChange={e => form.set({label: e.target.value})}
                    className="w-full input"/>
                ) : (
                    <p>{label.value}</p>
                )}
            </div>
            <div>
                {edit ? (
                    <>
                    <button disabled={form.isLoading} onClick={Update} className="btn btn-ghost btn-sm"><Check size={12} /></button>
                    <button disabled={form.isLoading} onClick={Delete} className="btn btn-ghost btn-sm"><Trash2 size={12} /></button>
                    </>
                ) : (
                    <button onClick={() => setEdit(true)} className="btn btn-ghost"><Pencil /></button>
                )}
            </div>
        </div>
    );
}